<template>
  <div class="ly_match_create">
    <div class="hd">
      <h2 class="tit">경기 만들기</h2>
      <a class="btn_close" href="javascript:;" @click="closeAll">닫기</a>
      <ul class="option">
        <li><a href="javascript:;" :class="{selected:userOutcome.gameType === 'pre'}">예정된 경기</a></li>
        <li><a href="javascript:;" :class="{selected:userOutcome.gameType === 'live'}">라이브 경기</a></li>
      </ul>
    </div>
    <div class="bd" style="overflow-y: auto;height: calc(100% - 125px);">

      <div class="game_info">
        <div class="item">
          <div class="summary">
            <div class="tit">{{ sportsClassItem.text }} - {{ item.lnm }}</div>
            <div class="time">{{ item.matchdate }}</div>
            <div class="team_area">
              <span class="team left">{{ item.hTeamNm }}</span>
              <span class="vs">vs</span>
              <span class="team right">{{ item.aTeamNm }}</span>
            </div>
          </div>
          <div class="game">
            <dl>
              <dt>{{ outcomes[0].mnm }}</dt>
              <dd v-for="(val, index) in outcomes" :key="index">
                <a :class="val.outcomeid === userOutcome.outcomeid ? 'selected' : ''" href="javascript:;">
                  <span class="tx">{{ teamText(val.kind, index) }} {{  val.dPoint }}</span>
                  <span class="odd">{{ val.price }}</span>
                </a>
              </dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="odds_info">
        <div class="tit">배당 변경</div>
        <div class="team">

          <div v-for="(val, index) in outcomes" :key="index" :class="index === 0 ? 'left' : 'right'">
            <span class="tx">{{ teamText(val.kind, index) }} {{ val.dPoint }}</span>
            <div class="odds">
              <button class="btn btn_down" @click="minusPrice(index)">내리기</button>
              <input type="number" class="inputbox" v-model="homePrice" v-if="index === 0"/>
              <input type="number" class="inputbox" v-model="awayPrice" v-else/>
              <button class="btn btn_up" @click="plusPrice(index)">올리기</button>
            </div>
          </div>

        </div>
      </div>

      <div class="amount_info">
        <dl class="amount_input">
          <dt>설정 골드입력</dt>
          <dd><input type="number" placeholder="골드를 입력해 주세요." v-model="gold" v-on:blur="convertGold"/></dd>
        </dl>
        <div class="tip">
          <p>· 설정 골드와 배당 만큼 승리, 패배 골드가 결정됩니다.</p>
          <p>· 1,000골드 단위로 설정 하실 수 있습니다.</p>
          <p>· 설정 골드는 최소 1,000골드 ~ 최대 500,000 골드입니다.</p>
        </div>
        <div class="prediction_info">
          <dl>
            <dt>승리시 총 획득 골드</dt>
            <dd class="win">{{ numberToString(winPrice) }}</dd>
          </dl>
          <dl>
            <dt>패배시 총 차감 골드</dt>
            <dd class="lose">{{ numberToString(lossPrice) }}</dd>
          </dl>
        </div>
        <div class="tip">
          <p>· 경기 결과는 해당 리그 공식 데이터값의 근거로 처리됩니다.</p>
          <p>· 게임 만들기 전 규정 및 게임 타입에 대한 설명을 이용방법에서 꼭 확인하세요.</p>
        </div>
      </div>
      <div class="btn_area">
        <a class="_btn btn_prev" href="javascript:;" @click="closeBetSlip">이전 단계</a>
        <a class="_btn btn_submit active" href="javascript:;" @click="createMatch">게임 만들기</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "match-bet-slip",
    data() {
      return {
        isLive: false,
        sportsList: '',
        homeOutcomeId: '',
        awayOutcomeId: '',
        homePrice: 0,
        awayPrice: 0,
        gold: 0
      }
    },
    methods: {
      teamText(kind, index) {


        if (lang[kind]) {
          return lang[kind]
        } else {
          if (index === 0) {
            return this.item.hTeamNm
          } else {
            return this.item.aTeamNm
          }

        }

      },
      closeAll() {
        this.$store.dispatch('match/clearAllPopup');
      },
      closeBetSlip() {
        gaEventer('예측배틀 - 게임 만들기', '이전 단계');
        this.$store.dispatch('match/closeBetSlip');
      },
      plusPrice(gameType) {
        if (!gameType) {
          this.homePrice = this.homePrice + 1
        } else {
          this.awayPrice = this.awayPrice + 1
        }
      },
      minusPrice(gameType) {
        if (!gameType) {
          this.homePrice = this.homePrice - 1
        } else {
          this.awayPrice = this.awayPrice - 1
        }
      },
      async createMatch() {
        gaEventer('예측배틀 - 게임 만들기', '게임 만들기');

        if (this.gold < 1000 || this.gold > 500000) {
          alert('설정 골드는 최소 1,000골드 ~ 최대 500,000 골드입니다.')
          return ;
        }

        if (confirm('등록을 하시겠습니까?') === false) {
          return ;
        }

        let res = await this._post("/v1/match", {
          gameType : this.userOutcome.gameType,
          sportsId : this.userOutcome.sportsId,
          homeOutcomeId: this.homeOutcomeId,
          awayOutcomeId: this.awayOutcomeId,
          homePrice: this.homePrice,
          awayPrice: this.awayPrice,
          gold: this.gold,
          matchId: this.userOutcome.matchid,
          marketId: this.userOutcome.marketid,
          outcomeId: this.userOutcome.outcomeid
        });

        if (res.data.message) {
          alert(res.data.message);
          this.$store.dispatch('match/clearAllPopup');
        }

        if (res.data.error) {
          return ;
        }

        conm.topuserinfo()
        if (this.$route.query.type) {
          this.$eventBus.$emit("matchList");
        } else {
          const routeQuery = {
            path: this.$route.path,
            query: {
              type : 'my',
              gameType : this.userOutcome.gameType,
              sportsId : this.userOutcome.sportsId
            }
          }
          this.$router.push(routeQuery)
        }

      },
      convertGold()
      {
        let gold = this.gold
        gold = String(gold)
        gold = gold.replace(/[^0-9.]/g, '')
        gold = parseInt(gold)
        if (gold > 500000) {
          gold = 500000
        }

        if (gold >= 1000) {
          gold = Math.round(gold / 1000) * 1000
        }

        this.gold = gold
      }
    },
    computed: {
      sportsClassItem() {
        const index = this._.findIndex(this.sportsCategory, {'id': this.item.sportsid});
        return this.sportsCategory[index]
      },
      item() {
        return this.$store.getters['match/selectMatch'];
      },
      userOutcome() {
        return this.$store.getters['match/userOutcome'];
      },
      outcomes() {
        const mnm = this.userOutcome.mnm;
        const list = this.item.markets[mnm];
        const items = _.filter(list, {'marketid': this.userOutcome.marketid});
        this.homePrice = items[0].price
        this.awayPrice = items[1].price
        this.homeOutcomeId = items[0].outcomeid
        this.awayOutcomeId = items[1].outcomeid
        return items
      },
      winPrice() {
        const index = _.findIndex(this.outcomes, {'outcomeid': this.userOutcome.outcomeid});
        const price = index !== 0 ? this.awayPrice : this.homePrice
        return  (this.gold >= 1000) ? Math.round(this.gold * price) : 0
      },
      lossPrice() {
        const index = _.findIndex(this.outcomes, {'outcomeid': this.userOutcome.outcomeid});
        const price = index !== 0 ? this.homePrice : this.awayPrice
        return (this.gold >= 1000) ? Math.round(this.gold * price) * -1 : 0
      },
    },
    watch: {
      homePrice(to) {
        to = to ? parseFloat(to).toFixed(2) : 1.01

        if (to > 100) {
          to = 100
        }

        this.homePrice = (parseFloat(to) <= 1) ? 1.01 : parseFloat(to)
      },
      awayPrice(to) {
        to = to ? parseFloat(to).toFixed(2) : 1.01

        if (to > 100) {
          to = 100
        }

        this.awayPrice = (parseFloat(to) <= 1) ? 1.01 : parseFloat(to)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/match/match-bet-slip.vue